import { createSellerIdStore } from '../../shared/mixpanel/stores/sellerId';

export default {
    sellerId: createSellerIdStore(),
};
